class AutoBoxHandler {
  constructor() {
    this.boxProducts = window.boxProductIds;
    this.cakeProductIds = (window.cakeProductIds || []).map(id => String(id));
    this.bakeryProductIds = (window.bakeryProductIds || []).map(id => String(id));
    this.bakeryDoubleBoxProductIds = (window.bakeryDoubleBoxProductIds || []).map(id => String(id));
    this.bakeryBoxId = window.bakeryBoxId ? String(window.bakeryBoxId) : null;

    this.allBoxVariantIds = Object.values(this.boxProducts).map(id => String(id));
    if (this.bakeryBoxId) this.allBoxVariantIds.push(this.bakeryBoxId);

    this.isUpdating = false;
    this.lastCakeCount = -1;
    this.lastBakeryCount = -1;
    this.init();
  }

  init() {
    console.log("AutoBox: Protection Mode Active");
    console.log("Tracking", this.cakeProductIds.length, "boxable products,", this.bakeryProductIds.length, "bakery products,", this.bakeryDoubleBoxProductIds.length, "double-box bakery products");

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver(() => {
        this.applyLocks();
        if (!this.isUpdating) {
          this.reconcileBoxes();
        }
      });
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }

    setInterval(() => this.applyLocks(), 300);

    document.addEventListener('cart:updated', () => this.reconcileBoxes());
    document.addEventListener('cart:refresh', () => this.reconcileBoxes());
    window.addEventListener('focus', () => this.reconcileBoxes());

    this.reconcileBoxes();
  }

  applyLocks() {
    const cartItems = document.querySelectorAll('.cart-item, [data-variant-id]');

    cartItems.forEach(item => {
      const variantId = item.getAttribute('data-variant-id');

      const isBox = this.allBoxVariantIds.includes(String(variantId));

      if (isBox) {
        const removeBtn = item.querySelector('.cart-item__remove, [is="cart-remove-item"], a[href*="url_to_remove"]');
        if (removeBtn) {
          removeBtn.style.display = 'none';
          removeBtn.style.pointerEvents = 'none';
          removeBtn.disabled = true;

          removeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log('AutoBox: Box removal blocked');
            this.reconcileBoxes();
          }, true);
        }

        const qtyInput = item.querySelector('quantity-input');
        if (qtyInput) {
          const plusBtn = qtyInput.querySelector('[name="plus"]');
          const minusBtn = qtyInput.querySelector('[name="minus"]');
          if (plusBtn) plusBtn.style.display = 'none';
          if (minusBtn) minusBtn.style.display = 'none';

          const input = qtyInput.querySelector('input');
          if (input) {
            input.disabled = true;
            input.style.pointerEvents = 'none';
          }
        }

        if (!item.querySelector('.box-required-label')) {
          const isBakeryBox = this.bakeryBoxId && String(variantId) === this.bakeryBoxId;

          const label = document.createElement('span');
          label.className = 'box-required-label';
          label.textContent = isBakeryBox ? 'Required for your bakery items' : 'Required for your cakes';
          label.style.cssText = 'font-size: 11px; color: #666; display: block; margin-top: 4px; font-style: italic;';

          const details = item.querySelector('.cart-item__details');
          if (details) {
            details.appendChild(label);
          }
        }
      }
    });
  }

  async reconcileBoxes() {
    if (this.isUpdating) {
      console.log('AutoBox: Already updating...');
      return;
    }

    try {
      const cartResponse = await fetch(`/cart.js?v=${Date.now()}`);
      const cart = await cartResponse.json();

      // ── Cake counting ──
      const cakeCount = cart.items.reduce((total, item) => {
        const isBox = this.allBoxVariantIds.includes(String(item.variant_id));
        const isCake = this.cakeProductIds.includes(String(item.product_id)) ||
                       this.cakeProductIds.includes(String(item.variant_id));

        if (!isBox && isCake) {
          console.log(' Found cake:', item.title, 'Qty:', item.quantity);
          return total + item.quantity;
        }
        return total;
      }, 0);

      // ── Bakery counting (double-box items need 2 boxes each) ──
      const bakeryCount = cart.items.reduce((total, item) => {
        const isBox = this.allBoxVariantIds.includes(String(item.variant_id));
        const isBakery = this.bakeryProductIds.includes(String(item.product_id)) ||
                          this.bakeryProductIds.includes(String(item.variant_id));
        const isDoubleBox = this.bakeryDoubleBoxProductIds.includes(String(item.product_id)) ||
                             this.bakeryDoubleBoxProductIds.includes(String(item.variant_id));

        if (!isBox && isBakery) {
          const boxesNeeded = isDoubleBox ? item.quantity * 2 : item.quantity;
          console.log(' Found bakery item:', item.title, 'Qty:', item.quantity, isDoubleBox ? '(2 boxes each)' : '');
          return total + boxesNeeded;
        }
        return total;
      }, 0);

      console.log('Total cakes:', cakeCount, '| Total bakery boxes needed:', bakeryCount);

      if (cakeCount === this.lastCakeCount && bakeryCount === this.lastBakeryCount) {
        return;
      }
      this.lastCakeCount = cakeCount;
      this.lastBakeryCount = bakeryCount;

      let targetBoxId = null;
      if (cakeCount > 0 && cakeCount <= 4) targetBoxId = this.boxProducts.small;
      else if (cakeCount > 4 && cakeCount <= 8) targetBoxId = this.boxProducts.medium;
      else if (cakeCount > 8 && cakeCount <= 12) targetBoxId = this.boxProducts.large;
      else if (cakeCount > 12) targetBoxId = this.boxProducts.xlarge;

      console.log('required cake box:', targetBoxId, '| required bakery box qty:', bakeryCount);

      let updates = {};
      let needsChange = false;

      // Cake tier: only one of small/medium/large/xlarge active at a time
      Object.values(this.boxProducts).map(String).forEach(id => {
        const itemInCart = cart.items.find(item => String(item.variant_id) === id);
        const currentQty = itemInCart ? itemInCart.quantity : 0;

        if (id === String(targetBoxId)) {
          if (currentQty !== 1) {
            updates[id] = 1;
            needsChange = true;
            console.log(' Adding/updating cake box:', id);
          }
        } else if (currentQty > 0) {
          updates[id] = 0;
          needsChange = true;
          console.log('Removing wrong cake box:', id);
        }
      });

      // Bakery box: 1:1 with bakery boxes needed (double-box items already counted as 2 above)
      if (this.bakeryBoxId) {
        const bakeryItemInCart = cart.items.find(item => String(item.variant_id) === this.bakeryBoxId);
        const currentBakeryQty = bakeryItemInCart ? bakeryItemInCart.quantity : 0;

        if (currentBakeryQty !== bakeryCount) {
          updates[this.bakeryBoxId] = bakeryCount;
          needsChange = true;
          console.log(' Syncing bakery box qty to:', bakeryCount);
        }
      }

      if (needsChange) {
        this.isUpdating = true;
        console.log('Updating cart...', updates);

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });

        const updatedCart = await response.json();
        console.log('Cart updated successfully');

        this.refreshCart(updatedCart);

        this.isUpdating = false;
      } else {
        console.log(' No changes needed');
      }
    } catch (e) {
      console.error(' AutoBox Error:', e);
      this.isUpdating = false;
    }
  }

  refreshCart(cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));

    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart }
    }));

    if (window.FoxTheme && FoxTheme.pubsub) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        cart: cart,
        source: 'autobox'
      });
    }

    console.log('Cart UI refreshed');
  }
}

if (!window.autoBoxRunning) {
  new AutoBoxHandler();
  window.autoBoxRunning = true;
}